const effectValues = {
  0: 'Bottom',
  1: 'Bottom Left',
  2: 'Bottom Right',
  3: 'Left',
  4: 'Right',
  5: 'Top',
  6: 'Top Left',
  7: 'Top Right'
}

const entryEffectValues = { ...effectValues, 8: 'Fade In' }
const exitEffectValues = { ...effectValues, 8: 'Fade Out' }

export {
  entryEffectValues,
  exitEffectValues
}



// WEBPACK FOOTER //
// ./src/components/playlists/playlistService.js